export default function Spinner() {
  return (
    <div className="flex items-center justify-center p-8">
      <div className="w-8 h-8 border-4 border-t-transparent rounded-full animate-spin"
        style={{ borderColor: 'var(--tg-theme-button-color)', borderTopColor: 'transparent' }}
      />
    </div>
  )
}
